import { render, staticRenderFns } from "./add-deal.vue?vue&type=template&id=77149894&"
import script from "./add-deal.vue?vue&type=script&lang=js&"
export * from "./add-deal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports